export * from './getArcDescription';
